import type { Market, Outcome } from '../@types';
import type { BetslipEvent } from '../contexts/BetslipContext';

type BetslipSelectionEvent = {
  id: string;
  name: string;
  isLive?: boolean;
  manualControl: boolean;
  source?: string;
};

type CreateBetslipSelectionArgs = {
  event: BetslipSelectionEvent;
  market: Market;
  outcome: Outcome;
};

export const createBetslipSelection = ({ event, market, outcome }: CreateBetslipSelectionArgs): BetslipEvent => ({
  outcomeId: outcome.id,
  odds: outcome.odds,
  eventName: event.name,
  marketId: market.id,
  marketName: market.name,
  marketShortName: market.shortName,
  outcomeName: outcome.name,
  outcomeShortName: outcome.shortName,
  eventId: event.id,
  providerId: event.source,
  source: event.source,
  specialValues: market.specialValues,
  marketType: market.marketType,
  marketDisplayType: market.displayType,
  isLive: event.isLive,
  manualControl: event.manualControl || market.manualControl,
  properties: outcome.properties,
});
